export const navItems = [
  { href: '/', label: 'Ana Sayfa' },
  { href: '/hakkimizda', label: 'Hakkımızda' },
  { href: '/neden-yeniden-co', label: 'Neden yeniden.co?' },
  { href: '/blog', label: 'Blog' },
  { href: '/sss', label: 'Sıkça Sorulan Sorular' },
  { href: '/iletisim', label: 'İletişim' },
];

export const tamirQuickLinks = [
  { href: '/sorgula', label: 'Tamir Sorgula' },
  { href: '/profilim/garantilerim', label: 'Garanti Sorgula' },
];
